import './Franquicias.css'

const Franquicias = () => {
    return (
        <picture>
            <img src='/assets/img/proximamente.png' alt='imagen proximamente' className="ProximamenteImg" />
        </picture>
    )
}

export default Franquicias